module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/familymart-183323fe75d217aa1547ab3760826087.jpg";